import { Swiper, SwiperSlide } from 'swiper/react';
import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');

export default function PowerHub() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const { locale } = useRouter();
    const imgLocale = getImageLocal(locale, ['au', 'cn', 'za']);

    const powerHubData = {
        [t('presale.product.modals.power_hub_swiper1_title')]: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec2_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec3_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec3_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec4_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec4_text'),
                },
            ],
            img: [`power-hub1_${imgLocale}.webp`, `power-hub1_${imgLocale}.png`],
        },
        [t('presale.product.modals.power_hub_swiper2_title')]: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper2_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper2_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper2_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper2_spec2_text'),
                },
            ],
            img: [`power-hub2_${imgLocale}.webp`, `power-hub2_${imgLocale}.png`],
        },
        [t('presale.product.modals.power_hub_swiper3_title')]: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec2_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec3_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec3_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec4_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec4_text'),
                },
            ],
            img: [`power-hub3_${imgLocale}.webp`, `power-hub3_${imgLocale}.png`],
        },
        [t('presale.product.modals.power_hub_swiper4_title')]: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper4_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper4_spec1_text'),
                },
            ],
            img: [`power-hub4_${imgLocale}.webp`, `power-hub4_${imgLocale}.png`],
        },
        [t('presale.product.modals.power_hub_swiper5_title')]: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper5_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper5_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper5_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper5_spec2_text'),
                },
            ],
            img: [`power-hub5_${imgLocale}.webp`, `power-hub5_${imgLocale}.png`],
        },
    };

    const renderSwiper = () => {
        const dom = [];
        for (const key in powerHubData) {
            const { specList, img } = powerHubData[key];
            dom.push(
                <SwiperSlide>
                    <div className="product-img">
                        <EFPic name={[img[0], img[1]]} className="fullImgs" alt={key} />
                    </div>
                    <div className="spec-list">
                        {specList.map((item: any, index: number) => (
                            <div className="spec-item" key={index}>
                                <div className="title">{item.title}</div>
                                <div className="text">{item.text}</div>
                            </div>
                        ))}
                    </div>
                </SwiperSlide>,
            );
        }
        return dom;
    };

    const onTabnavScroll = (index: number) => {
        const separatorWidth = document.querySelector('.separator')?.scrollWidth || 10;
        const tabnavWidth = document.querySelector('.tabnav')?.scrollWidth || 315;
        const currentTabnavWidth = document.querySelector(`.tabnav${index}`)?.scrollWidth || 0;
        const offset = (tabnavWidth - currentTabnavWidth) / 2;
        let scrollWidth = 0;
        for (let i = 0; i < index; i++) {
            const width = document.querySelector(`.tabnav${i}`)?.scrollWidth || 0;
            scrollWidth += width + separatorWidth;
        }
        document.querySelector('.tabnav-items')?.scrollTo({ left: scrollWidth - offset, behavior: 'smooth' });
    };

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active) {
            swiper?.slideTo(index);
        }
    };

    return (
        <div className={`${css.PowerHub} PowerHub`}>
            <div className="texta-title-a1">{t('presale.product.modals.power_hub_title1')}</div>
            <div className="texta-title-a2">{t('presale.product.modals.power_hub_title2')}</div>
            <div className="swiper-content">
                <div className="tablist-wrapper">
                    <div className="tabnav">
                        <ul className="tabnav-items">
                            <li className={`tabnav-item tabnav0 ${active === 0 && 'current'}`} onClick={() => onSwiperSlideTo(0)}>
                                <span className="tabnav-link">{t('presale.product.modals.power_hub_swiper1_title')}</span>
                            </li>
                            <span className="separator" aria-hidden="true">
                                /
                            </span>
                            <li className={`tabnav-item tabnav1 ${active === 1 && 'current'}`} onClick={() => onSwiperSlideTo(1)}>
                                <span className="tabnav-link">{t('presale.product.modals.power_hub_swiper2_title')}</span>
                            </li>
                            <span className="separator" aria-hidden="true">
                                /
                            </span>
                            <li className={`tabnav-item tabnav2 ${active === 2 && 'current'}`} onClick={() => onSwiperSlideTo(2)}>
                                <span className="tabnav-link">{t('presale.product.modals.power_hub_swiper3_title')}</span>
                            </li>
                            <span className="separator" aria-hidden="true">
                                /
                            </span>
                            <li className={`tabnav-item tabnav3 ${active === 3 && 'current'}`} onClick={() => onSwiperSlideTo(3)}>
                                <span className="tabnav-link">{t('presale.product.modals.power_hub_swiper4_title')}</span>
                            </li>
                            <span className="separator" aria-hidden="true">
                                /
                            </span>
                            <li className={`tabnav-item tabnav4 ${active === 4 && 'current'}`} onClick={() => onSwiperSlideTo(4)}>
                                <span className="tabnav-link">{t('presale.product.modals.power_hub_swiper5_title')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <Swiper
                    className="power-hub-swiper"
                    slidesPerView={'auto'}
                    loop
                    spaceBetween={30}
                    initialSlide={0}
                    preloadImages={false}
                    lazy={true}
                    centeredSlides={true}
                    grabCursor={true}
                    pagination={{
                        clickable: true,
                    }}
                    onSlideChange={(swiper: any) => {
                        const { activeIndex } = swiper;
                        setActive(activeIndex % 5 || 0);
                        onTabnavScroll(activeIndex % 5);
                    }}
                    onSwiper={(swiper: any) => setSwiper(swiper)}
                >
                    {renderSwiper()}
                </Swiper>
            </div>
        </div>
    );
}
